import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular/lazy';
import { StorageService } from 'src/app/services/storage.service';
import { ObserverService } from 'src/app/services/observer.service';
import { RegisterService } from 'src/app/services/register.service';

@Component({
    selector: 'app-settings-change-register',
    templateUrl: './settings-change-register.page.html',
    styleUrls: ['./settings-change-register.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SettingsChangeRegisterPage implements OnInit {

    registers = null;
    selected_register_id = null;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private storageService: StorageService,
        private observerService: ObserverService,
        private registerService: RegisterService
    ) { }

    ngOnInit() {
        this.storageService.get('register_id').then((register_id) => {
            this.selected_register_id = register_id;
        });

        this.registerService.getRegisters().then((registers) => {
            if (registers) {
                this.sortRegisters(registers);
            }
        });

        this.observerService.subscribe('register_added|settings_change_register_modal', (register) => {
            if (register) {
                let registers = this.registers;
                registers.push(register);
                this.sortRegisters(registers);
            }
        });

        this.observerService.subscribe('register_updated|settings_change_register_modal', (register) => {
            if (register) {
                let registers = this.registers;
                for (let i = 0; i < registers.length; i++) {
                    if (registers[i].id === register["id"]) {
                        registers[i] = register;
                        break;
                    }
                }
                this.sortRegisters(registers);
            }
        });

        this.observerService.subscribe('register_deleted|settings_change_register_modal', (register) => {
            if (register) {
                let registers = this.registers;
                for (let i = 0; i < registers.length; i++) {
                    if (registers[i].id === register["id"]) {
                        registers.splice(i, 1);
                        break;
                    }
                }
                this.sortRegisters(registers);
            }
        });

        this.observerService.subscribe('registers_changed|settings_change_register_modal', (registers) => {
            if (registers) {
                this.sortRegisters(registers);
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("register_added|settings_change_register_modal");
        this.observerService.destroy("register_updated|settings_change_register_modal");
        this.observerService.destroy("register_deleted|settings_change_register_modal");
        this.observerService.destroy("registers_changed|settings_change_register_modal");
    }

    close() {
        this.modalController.dismiss();
    }

    sortRegisters(registers) {
        registers.sort((a, b) => {
            if (a['title'].toLowerCase() < b['title'].toLowerCase()) { return -1; }
            if (a['title'].toLowerCase() > b['title'].toLowerCase()) { return 1; }
            return 0;
        });
        this.registers = registers;
    }

    update() {
        this.storageService.set('register_id', this.selected_register_id).then(() => {
            this.observerService.publish('register_id_changed', this.selected_register_id);
        });
        this.modalController.dismiss();
    }
}
